var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Demand" } },
        [
          _c(
            "Accord",
            { attrs: { title: "Consumption" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "aggregationDemandConsumption",
                  settings: _vm.consumptionSettings,
                  isAggregation: true,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }